export const SET_COMPANY_NAME = "SET_COMPANY_NAME";
